import React from "react";
import Header from "../Comoponents/Header";
import Footer from "../Comoponents/Footer";
import { useTranslation, Trans } from "react-i18next";
function TermsCondition() {
  const { t, i18n } = useTranslation();
  return (
    <>
      <Header />
      {/* <div className="privacy-policy">
        <div className="container">
          <h1>Terms & Conditions</h1>
         

          <section>
            <h2>1. Introduction</h2>
            <p>
              Welcome to TaraRide ("we", "our", "us"). These Terms and
              Conditions govern your access to and use of our ride-booking
              platform and related services within the Arab Republic of Egypt.
              By using our website or mobile application, you agree to comply
              with and be bound by these Terms.
            </p>
            <p>
              If you do not agree with any part of these Terms, you must not use
              our services. These Terms are legally binding and apply to all
              users, including riders and drivers.
            </p>
          </section>

          <section>
            <h2>2. Eligibility</h2>
            <p>
              To use our services, you must be at least 18 years of age and
              legally capable of entering into binding agreements under Egyptian
              law. By accessing our platform, you confirm that you meet these
              requirements.
            </p>
            <p>
              We reserve the right to suspend or terminate accounts that do not
              comply with eligibility requirements or violate these Terms.
            </p>
          </section>

          <section>
            <h2>3. Account Registration</h2>
            <p>
              Users are required to create an account by providing accurate and
              complete information. You are responsible for maintaining the
              confidentiality of your account credentials and for all activities
              conducted under your account.
            </p>
            <p>
              Any unauthorized use of your account must be reported immediately.
              We are not liable for any loss resulting from unauthorized access
              due to your negligence.
            </p>
          </section>

          <section>
            <h2>4. Use of Services</h2>
            <p>
              TaraRide provides a platform to connect riders with independent
              drivers for transportation services. We do not own or operate
              vehicles and are not a transportation provider.
            </p>
            <p>
              Users agree to use the platform only for lawful purposes and must
              not engage in fraudulent, abusive, or harmful activities while
              using our services.
            </p>
          </section>

          <section>
            <h2>5. Booking and Payments</h2>
            <p>
              All ride bookings are subject to availability. Prices are
              determined based on distance, time, and demand. Users agree to pay
              all applicable charges associated with their rides.
            </p>
            <p>
              Payments may be processed through third-party payment providers.
              We are not responsible for any payment processing errors or
              failures caused by external providers.
            </p>
          </section>

          <section>
            <h2>6. Cancellations and Refunds</h2>
            <p>
              Users may cancel rides subject to applicable cancellation
              policies. Cancellation fees may apply depending on the timing of
              the cancellation.
            </p>
            <p>
              Refunds, if applicable, will be processed in accordance with our
              refund policy and may take several business days to complete.
            </p>
          </section>

          <section>
            <h2>7. User Conduct</h2>
            <p>
              Users are expected to behave respectfully and responsibly while
              using the platform. Any form of harassment, abuse, illegal
              activity, or misconduct towards drivers or other users is strictly
              prohibited.
            </p>
            <p>
              We reserve the right to suspend or permanently ban users who
              violate these conduct standards.
            </p>
          </section>

          <section>
            <h2>8. Limitation of Liability</h2>
            <p>
              TaraRide acts solely as an intermediary platform between riders
              and drivers. We are not liable for any damages, injuries, losses,
              or disputes arising during or after a ride.
            </p>
            <p>
              To the fullest extent permitted by Egyptian law, we disclaim all
              liability for indirect, incidental, or consequential damages.
            </p>
          </section>

          <section>
            <h2>9. Privacy</h2>
            <p>
              Your use of our services is also governed by our Privacy Policy,
              which explains how we collect and process your personal data.
            </p>
            <p>
              By using our platform, you consent to the handling of your data in
              accordance with applicable Egyptian data protection laws.
            </p>
          </section>

          <section>
            <h2>10. Intellectual Property</h2>
            <p>
              All content, trademarks, logos, and materials on the platform are
              the property of TaraRide or its licensors. Users are not
              permitted to copy, reproduce, or distribute any content without
              prior written consent.
            </p>
          </section>

          <section>
            <h2>11. Termination</h2>
            <p>
              We reserve the right to suspend or terminate your access to our
              services at any time, without prior notice, if you violate these
              Terms or engage in harmful activities.
            </p>
            <p>
              Upon termination, your right to use the platform will immediately
              cease.
            </p>
          </section>

          <section>
            <h2>12. Governing Law</h2>
            <p>
              These Terms shall be governed by and interpreted in accordance
              with the laws of the Arab Republic of Egypt.
            </p>
            <p>
              Any disputes arising from these Terms shall be subject to the
              exclusive jurisdiction of the competent courts in Egypt.
            </p>
          </section>

          <section>
            <h2>13. Changes to Terms</h2>
            <p>
              We may update these Terms and Conditions from time to time.
              Changes will be effective upon posting on this page.
            </p>
            <p>
              Continued use of our services after updates constitutes acceptance
              of the revised Terms.
            </p>
          </section>

          <section>
            <h2>14. Contact Us</h2>
            <p>Email: info@tararide.com</p>
            <p>Phone: +20 1287690960</p>
          </section>
        </div>
      </div> */}
      <div className="privacy-policy">
  <div className="container">

    <h1>{t("terms.title")}</h1>

    {/* 1 */}
    <section>
      <h2>{t("terms.sec1.title")}</h2>
      <p>{t("terms.sec1.p1")}</p>
      <p>{t("terms.sec1.p2")}</p>
    </section>

    {/* 2 */}
    <section>
      <h2>{t("terms.sec2.title")}</h2>
      <p>{t("terms.sec2.p1")}</p>
      <p>{t("terms.sec2.p2")}</p>
    </section>

    {/* 3 */}
    <section>
      <h2>{t("terms.sec3.title")}</h2>
      <p>{t("terms.sec3.p1")}</p>
      <p>{t("terms.sec3.p2")}</p>
    </section>

    {/* 4 */}
    <section>
      <h2>{t("terms.sec4.title")}</h2>
      <p>{t("terms.sec4.p1")}</p>
      <p>{t("terms.sec4.p2")}</p>
    </section>

    {/* 5 */}
    <section>
      <h2>{t("terms.sec5.title")}</h2>
      <p>{t("terms.sec5.p1")}</p>
      <p>{t("terms.sec5.p2")}</p>
    </section>

    {/* 6 */}
    <section>
      <h2>{t("terms.sec6.title")}</h2>
      <p>{t("terms.sec6.p1")}</p>
      <p>{t("terms.sec6.p2")}</p>
    </section>

    {/* 7 */}
    <section>
      <h2>{t("terms.sec7.title")}</h2>
      <p>{t("terms.sec7.p1")}</p>
      <p>{t("terms.sec7.p2")}</p>
    </section>

    {/* 8 */}
    <section>
      <h2>{t("terms.sec8.title")}</h2>
      <p>{t("terms.sec8.p1")}</p>
      <p>{t("terms.sec8.p2")}</p>
    </section>

    {/* 9 */}
    <section>
      <h2>{t("terms.sec9.title")}</h2>
      <p>{t("terms.sec9.p1")}</p>
      <p>{t("terms.sec9.p2")}</p>
    </section>

    {/* 10 */}
    <section>
      <h2>{t("terms.sec10.title")}</h2>
      <p>{t("terms.sec10.p1")}</p>
    </section>

    {/* 11 */}
    <section>
      <h2>{t("terms.sec11.title")}</h2>
      <p>{t("terms.sec11.p1")}</p>
      <p>{t("terms.sec11.p2")}</p>
    </section>

    {/* 12 */}
    <section>
      <h2>{t("terms.sec12.title")}</h2>
      <p>{t("terms.sec12.p1")}</p>
      <p>{t("terms.sec12.p2")}</p>
    </section>

    {/* 13 */}
    <section>
      <h2>{t("terms.sec13.title")}</h2>
      <p>{t("terms.sec13.p1")}</p>
      <p>{t("terms.sec13.p2")}</p>
    </section>

    {/* 14 */}
    <section>
      <h2>{t("terms.sec14.title")}</h2>
      <p>{t("terms.sec14.p1")}</p>
      <p>{t("terms.sec14.p2")}</p>
    </section>

  </div>
</div>
      <Footer />
    </>
  );
}

export default TermsCondition;
